<template>
    <div>
        <div class="filter_container">
            <div class="filter_item" :class="{'filter_item--open':root_elem.isActive}" :key="root_index" v-for="(root_elem, root_index) in filtersData">
                <div class="closed" @click.stop="tabControll(root_index)">
                    <span class="x2">{{root_elem.label}}</span>
                    <div class="arrow_container" :class="{'tab_opened' : root_elem.isActive}">
                        <svg class="arrow_icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             width="10px" height="10px" viewBox="0 0 292.362 292.362" style="fill: #6f6f6f;"
                             xml:space="preserve">
                    <path d="M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424
                    C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428
                    s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z"/>
                    </svg>
                    </div>
                </div>
                <div @click="stopProp" class="opened" v-if="root_elem.isActive" >
                    <div class="counter">
<!--                        <span class="x3">Количество:</span>-->
                        <input class="f_input" min="1" v-if="root_elem.limits.max != 1" v-model="root_elem.count" @change="setTabCount(root_elem.id, root_elem.count, root_index)" :type="root_elem.input" :id="root_elem.id" :name="root_elem.id"/>
                    </div>
                    <div class="child_elems">
                        <div
                                class="child_elem"
                                :key="ch_index"
                                v-for="(ch_elem, ch_index) in root_elem.child">
                            <div
                                    :class="{disabled: ch_elem.active == false}"
                                    class="child_elem_type"
                                    v-if="ch_elem.input=='checkbox' && ch_elem.value.length != 0">
                                <p class="x3">{{ch_elem.label}}</p>

                                <multiselect
                                        :deselectGroupLabel="'deselect'"
                                        :deselectLabel="'Удалить'"
                                        :selectedLabel="'Выбрано'"
                                        :selectLabel="'Выбрать'"
                                        v-model="ch_elem.value.selected"
                                        :options="ch_elem.value"
                                        tag-placeholder="Добавить"
                                        placeholder="Выберите один или несколько вариантов"
                                        :multiple="true"
                                        label="name"
                                        track-by="code"
                                        @select="setMultiToTemp(root_elem.id, ch_elem.id, $event, root_index, ch_index)"
                                ></multiselect>

                            </div>
                            <div
                                    class="child_elem_type"
                                    v-if="(ch_elem.input=='number' || ch_elem.input=='range') && (ch_elem.limits.min != ch_elem.limits.max)">
                                <p class="x3" :for="ch_elem.id">{{ch_elem.label}}</p>
                                <div class="range_container">
                                    <input
                                            :step="ch_elem.limits.max > 1 ? 1 : 0.1"

                                            type="number"
                                            :id="ch_elem.id+'///min'"
                                            :name="ch_elem.id+'///min'"
                                            v-model="ch_elem.limits.minv"
                                            class="range"
                                            :class="{changed: ch_elem.changed}"
                                            @change="setValueRange(root_elem.id, ch_elem.id, $event, 'min', root_index, ch_index)"
                                            :min="ch_elem.limits.min"
                                            :max="ch_elem.limits.max"
                                    />
                                    <span>-</span>
                                    <input
                                            :step="ch_elem.limits.max > 1 ? 1 : 0.1"
                                            type="number"
                                            :id="ch_elem.id+'///max'"
                                            :name="ch_elem.id+'///max'"
                                            v-model="ch_elem.limits.maxv"
                                            class="range"
                                            :class="{changed: ch_elem.changed}"
                                            @change="setValueRange(root_elem.id, ch_elem.id, $event, 'max', root_index, ch_index)"
                                            :min="ch_elem.limits.min"
                                            :max="ch_elem.limits.max"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <a @click="pushFromTempToSelected(root_elem.id, root_index)" title="Добавить" class="product-card__button">Добавить</a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import goals from '../../goals'
    import Multiselect from 'vue-multiselect'

    export default {
        components: { Multiselect },
        name: "FilterTabs",
        props: ["filtersData"],
        data(){
            return {
                temp_selected: {}
            }
        },
        methods: {
            setTabCount (root_elem_id, count, root_index) {
                this.temp_selected[root_elem_id].changed = true
                this.temp_selected[root_elem_id].count = count
            },
            closeTab(root_index) {
                this.filtersData[root_index].isActive = false
            },
            pushFromTempToSelected(root_elem_id, root_index) {

                this.$emit('pushFromTempToSelected', this.temp_selected[root_elem_id])
                this.closeTab(root_index)
                this.multiClear()
                window.removeEventListener('click', this.closeTabsListner)

            },
            stopProp () {
                event.stopPropagation()
            },
            pushTemplateToTemp(root_index) {
                this.temp_selected = {}
                this.filtersData[root_index].count = 0
                let root_elem_id = this.filtersData[root_index].id
                return this.$set(this.temp_selected, root_elem_id, {
                    root_id: root_elem_id,
                    root_index: root_index,
                    label: this.filtersData[root_index].label,
                    count: 1,
                    child: [],
                    changed: false,
                });
            },
            closeTabsListner () {
                this.filtersData.forEach(i => {
                    i.isActive = false
                    i.changed = false
                })
                if (this.temp_selected[Object.keys(this.temp_selected)[0]].changed) {
                    this.$emit('pushFromTempToSelected', this.temp_selected[Object.keys(this.temp_selected)[0]])
                }

                this.multiClear()
                this.temp_selected = {}
                window.removeEventListener('click', this.closeTabsListner)
            },
            tabControll(root_index) {
                this.filtersData[root_index].isActive = !this.filtersData[root_index].isActive
                if (this.filtersData[root_index].isActive) {

                    window.addEventListener('click', this.closeTabsListner)
                    this.pushTemplateToTemp(root_index)
                }
                this.filtersData.forEach((i, index) => {
                    if (root_index !== index) {
                        i.isActive = false
                    }
                })
                goals.showBlock(this.filtersData[root_index].label)
            },
            setMultiToTemp(root_elem_id, ch_elem_id, e, root_index, ch_index){

                this.temp_selected[root_elem_id].changed = true

                if (this.filtersData[root_index].count == 0) {
                    this.filtersData[root_index].count = 1
                }

                let val = e
                let row = {
                    child_id: ch_elem_id,
                    value: val,
                    child_index: ch_index,
                };

                return this.temp_selected[root_elem_id].child.push(row)

            },

            multiClear() {

                this.filtersData.forEach( t => {
                    t.child.forEach( c => {
                        if (c.value.selected) {
                            c.value.selected = []
                        }
                    })
                })

            },


            setValueRange(
                root_elem_id,
                child_elem_id,
                e,
                rangetype,
                root_index,
                ch_index
            ) {

                let val = e.target.valueAsNumber;

                if (!this.filtersData[root_index]["child"][ch_index].changed) {
                    this.filtersData[root_index]["child"][ch_index].changed = true
                }

                this.temp_selected[root_elem_id].changed = true

                if (this.filtersData[root_index].count == 0) {
                    this.filtersData[root_index].count = 1
                }

                let row = {}

                if (rangetype === "min") {

                    row = {
                        child_id: child_elem_id,
                        min: val,
                        max: this.filtersData[root_index]["child"][ch_index].limits.max,
                        child_index: ch_index,
                    }

                } else {

                    row = {
                        child_id: child_elem_id,
                        min: this.filtersData[root_index]["child"][ch_index].limits.min,
                        max: val,
                        child_index: ch_index,
                    }
                }

                let parent = {
                    count: this.filtersData[root_index].count,
                    child: [row],
                    root_id: root_elem_id,
                    root_index: root_index,
                }

                if (!this.temp_selected[root_elem_id].child) {
                    return this.$set(this.temp_selected, root_elem_id, parent)
                }

                for (var i = 0; i < this.temp_selected[root_elem_id].child.length; i++) {
                    if (this.temp_selected[root_elem_id].child[i].child_id == child_elem_id) {
                        return this.temp_selected[root_elem_id].child[i][rangetype] = val
                    }
                }

                return this.temp_selected[root_elem_id].child.push(row)
            },

            

        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect__select {
        width: 30px;
    }
    .multiselect__tag {
        white-space: normal;
        overflow: auto;
    }
    .multiselect__tags {
        padding: 6px 30px 0 6px;
        border-radius: 3px;
    }
    .multiselect__input, .multiselect__single {
        font-size: 12px;
        font-weight: 300!important;
    }
    ul.multiselect__content {
        padding: 0;
    }

    .multiselect__element {
        font-size: 12px;
        font-weight: 300;
    }

    .multiselect__tag {
        background: #008f86;
        font-weight: 300;
        border-radius: 3px;
    }

    .multiselect__tag-icon:focus,.multiselect__tag-icon:hover {
        background: #9f0412;
    }

    .multiselect__option--highlight {
        background: #008f86;
        outline: none;
        color: #fff;
    }

    .multiselect__option--highlight:after {
        content: attr(data-select);
        background: #008f86;
        color: #fff;
    }

    .multiselect__placeholder {
        font-weight: 300;
    }

    .multiselect__option--selected.multiselect__option--highlight {
        background: #9f0412;
        color: #fff
    }

    .multiselect__option--selected.multiselect__option--highlight:after {
        background: #9f0412;
        content: attr(data-deselect);
        color: #fff
    }

    .multiselect__tag-icon {
        border-radius: 3px;
        height: 22px;
    }

    .multiselect__option:after {
        display: none;
    }

    .multiselect__option {
        padding: 7px;
        min-height: auto;
        font-size: 14px;
        white-space: break-spaces;
    }
    .multiselect {
        cursor: pointer;
    }

</style>

<style scoped>
    .changed {
        color: #3a4e55!important;
    }
    .child_elem {
        margin-bottom: 10px;
    }
    .counter {
        margin-bottom: 10px;
        display: flex;
    }

    .counter input {
        font-weight: 500;
        font-size: 14px;
    }

    .x2 {
        font-size: 14px;
    }

    .x3 {
        font-size: 14px;
        margin-bottom: 5px;
        margin-top: 0;
        font-weight: 300;
        line-height: inherit;
    }

    .range_container {
        display: flex;
    }

    .range {
        width: 100%;
        color: #969696;
        font-size: 14px;
        font-weight: 500;
    }

    .closed {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 7px 10px;
        cursor: pointer;
    }

    .opened {
        position: absolute;
        top: 0;
        left:0;
        padding: 10px;
        background: #ededed;
        width: 100%;
        top: 100%;
        z-index: 100;
        margin-top: -10px;
    }

    .opened span{
        display: block;
    }

    .arrow_container{
        position: relative;
        width: 10px;
        height: 10px;
    }

    .tab_opened .arrow_icon {
        transform: none;
    }

    .arrow_icon{
        position: absolute;
        z-index: 10;
        transform: rotate(
                -90deg
        );
        transition-duration: .2s;
    }

    .filter_item--open {
        border-radius: 3px 3px 0 0!important;
    }

    .filter_item--open .closed {
        box-shadow: 0px 3px 10px rgb(0 0 0 / 16%);
    }

    .filter_item--open .opened {
        box-shadow: 0px 12px 10px rgb(0 0 0 / 16%);
    }

    .filter_item {
        flex-grow: 1;
        width: 32%;
        background: #ededed;
        position: relative;
        border-radius: 3px;
        min-width: 230px;
    }

    .filter_container {
        display: flex;
        flex-wrap: wrap;
        color: #3a4e55;
        font-weight: bold;
        justify-content: space-between;
        gap: 10px;
    }

    .range_container span{
        padding: 0 5px;
    }

    @media screen and (max-width: 550px) {
      .filter_item {
        width: 100%;
        margin-bottom: 10px;
      }
      .filter_container {
        gap: 0;
      }
    }
</style>